import React, { memo } from 'react';

/**
 * 商品名キーワード入力コンポーネント
 *
 * 商品名の部分一致検索用テキスト入力。
 * 表示は REACT_APP_ENABLE_PRODUCT_NAME_SEARCH フラグで制御される（SearchPanel 側）。
 * maxLength=100 はバックエンドのバリデーション（101文字以上で422）に合わせた値。
 *
 * @param {Object} props
 * @param {string} props.value - 現在の入力値
 * @param {Function} props.onChange - 値変更コールバック（引数: string）
 */
const ProductNameKeyword = ({ value, onChange }) => (
  <input
    type="text"
    className="dc-keyword-input"
    placeholder="商品名キーワード（最大100文字）"
    maxLength={100}
    value={value}
    onChange={(e) => onChange(e.target.value)}
  />
);

export default memo(ProductNameKeyword);
